import React from 'react';
import EkomiComponent from './EkomiComponent';

const EkomiWidget = () => (
  <EkomiComponent rating={4.5} count={18000} link="https://www.ekomi.de/bewertungen-immobilien-scout24.html" />
);

export default EkomiWidget;
